import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0C1D33',
        secondary: '#DD5E4E'
      }
    }
  }
})
